import React, { MouseEvent, ReactNode } from 'react';
import { Element } from './LoginButton.styles';
import Text from '@/components/typography/Text/Text';
import { ACCOUNT_LINK } from '@/helpers/browser';
import Link from '@/providers/Link';

export type LoginButtonProps = {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
};

const LoginButton = ({ children, ...props }: LoginButtonProps) => {
  return (
    <Element>
      <Text>
        Solicite um <Link href="/viagens/crie-seu-roteiro">orçamento personalizado</Link> ou acesse a{' '}
        <Link href={ACCOUNT_LINK.login}>Área do Agente</Link>.
      </Text>
      <Text>
        Caso não tenha cadastro,{' '}
        <a href={ACCOUNT_LINK.signup} target="_blank">
          clique aqui
        </a>{' '}
        para fazer seu cadastro.
      </Text>
    </Element>
  );
};

export default LoginButton;
